import script from "./menu-superior.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-superior.vue?vue&type=script&setup=true&lang=js"

import "./menu-superior.vue?vue&type=style&index=0&id=b2494548&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2494548"]])

export default __exports__